function Header({

    title,

    subTitle,

    right

}) {

    return (

        <div className="page-header">

            <div className="header-top">

                <div>

                    <h2 className="page-title">

                        {title}

                    </h2>

                    <div className="page-sub-title">

                        {subTitle}

                    </div>

                </div>

                <div className="header-right">

                    {right}

                </div>

            </div>

        </div>

    );

}

export default Header;